/**
 * Vasaloppet Mina Sidor
 * Author: Peter Löfås, peter@lofas.se
 */

import React, { Fragment } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ManageEvents from './Events/ManageEvents';
import ManagePaymentChannels from './Orders/ManagePaymentChannels';
import ManageUsers from './Users/ManageUsers';
import ManageCronJobs from './ManageCronJobs';
import ManagePOSPlaces from './ManagePOSPlaces';
import ManageDiplomas from './Events/ManageDiplomas';
import ManageCustomSettings from './CustomSetting/ManageCustomSettings';
import ManageIceAdmins from './IceAdmins/ManageIceAdmins';
import ManageCounters from './Counters/ManageCounters';

interface State {
   curTab: number;
}

const sections: { label: string; render: () => JSX.Element }[] = [
   { label: "Evenemang", render: () => <ManageEvents /> },
   { label: "Betalsätt", render: () => <ManagePaymentChannels /> },
   { label: "Användare", render: () => <ManageUsers /> },
   { label: "Schemalagda jobb", render: () => <ManageCronJobs /> },
   { label: "POS Terminaler", render: () => <ManagePOSPlaces /> },
   { label: "Diplom", render: () => <ManageDiplomas /> },
   { label: "Settings", render: () => <ManageCustomSettings /> },
   { label: "ICE-admins", render: () => <ManageIceAdmins /> },
   { label: "Counters", render: () => <ManageCounters /> },
];

class ManageSettings extends React.Component<RouteComponentProps, State> {
   constructor(props: RouteComponentProps) {
      super(props);
      this.state = { curTab: 0 };
   }

   render() {
      const current = sections[this.state.curTab] ?? sections[0];
      return (
         <Fragment>
            <FormControl variant="outlined" size="small" style={{ minWidth: 260, marginBottom: 12 }}>
               <InputLabel id="settings-section-label">Inställning</InputLabel>
               <Select
                  labelId="settings-section-label"
                  label="Inställning"
                  value={this.state.curTab}
                  onChange={(ev) => this.setState({ curTab: ev.target.value as number })}
               >
                  {sections.map((s, i) => (
                     <MenuItem key={s.label} value={i}>{s.label}</MenuItem>
                  ))}
               </Select>
            </FormControl>
            {current.render()}
         </Fragment>
      );
   }
}

export default withRouter(ManageSettings);
